<template>
  <div class="reports-add-jobs">
    <el-button
      style="width: 100%"
      size="small" class="add" :type="isSelect ? 'default' : 'primary'" @click="openDialog"
    >
      {{ isSelect ? 'Сменить раздел' : '+ Выбрать раздел' }}
    </el-button>

    <el-dialog title="Выбрать раздел" :visible.sync="dialogObject">
      <div class="add-jobs">
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div class="jobs-ul">
          <div
            @click="save(list)"
            class="jobs-li" v-for="(list, index) in filteredList" :key="index"
          >
            <span>{{ list.name }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {getChildList} from '@/utils/getChild';
import _ from 'lodash';

export default {
  name: 'AddDoc',
  props: ['isSelect', 'confirmDisable'],
  data() {
    return {
      search: '',
      dialogObject: false,
      unit: '',
      role: 'admin',
      list: [],
      form: {
        value: '',
        unit: '',
      },
    };
  },
  computed: {
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },

  async mounted() {
    this.fetchTree();
    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id).get().then((sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[authFirestore.currentUser.uid];

          if (data.isDemo) {
            this.role = 'admin';
          }
          this.loading = false;
        }
      }
    });
  },

  methods: {
    fetchTree() {
      this.loader = true;
      const result = [];
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('documentation')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        this.list = _.orderBy(getChildList(result), 'index', ['asc']);
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    openDialog() {
      if (this.confirmDisable) {
        this.$emit('add-objects', null);
        return this.dialogObject = true;
      }
      if (this.isSelect && this.$route.params.type !== 'TECH' && this.$route.params.type !== 'PROF') {
          this.$emit('add-objects', null);
          this.dialogObject = true;
      } else {
        this.$emit('add-objects', '');
        this.dialogObject = true;
      }
    },
    save(object) {
      this.$emit('add-objects', {
        name: object.name,
        id: object.id,
      });
      this.close();
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.form.value = '';
      this.form.unit = '';
    },
  },
};
</script>

<style lang="scss">
.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 0 10px;
    width: calc(100% - 20px);
    justify-content: flex-start;
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/components/AddDoc.vue